import { put, takeLatest } from "redux-saga/effects";
import { GetDataPermissionSuccessAction, RequertDataPermissionFailedAction } from "../actions";
import { GET_DATA_PERMISSION } from "../actions/actionsTypes";
import { Api } from "./api";


function* GetDataPermission(DataMenu){
    try{
        const DataPermission = yield Api.GetDataPermissionFromApi(DataMenu.DataMenu);
        yield put(GetDataPermissionSuccessAction(DataPermission));
    }catch(error)
    {
        yield put(RequertDataPermissionFailedAction("error"));
    }
}

export function* watchGetDataPermission(){
    yield takeLatest(GET_DATA_PERMISSION, GetDataPermission);
}